import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './AreaPartsMultiAds.css';
import { MoreAreasPartsLink } from './components';
import { AreaLink } from './components/AreaLink';
import { TAreaPartForDesktopSchema } from '../../types/results';

export interface IAreaPartsMultiAdsProps {
  areaParts: TAreaPartForDesktopSchema[];
  fullUrl: string;
  maxSlotsToShow?: number;
}

export const MAX_AREA_PARTS_TO_SHOW = 5;

export function AreaPartsMultiAds(props: IAreaPartsMultiAdsProps) {
  const { areaParts, fullUrl, maxSlotsToShow = MAX_AREA_PARTS_TO_SHOW } = props;

  const isMultiAds = areaParts && areaParts.length;

  if (!isMultiAds) {
    return null;
  }

  const shouldRenderFloorColumn = areaParts.some(({ floor }) => !!floor);

  const rows = areaParts.slice(0, maxSlotsToShow).map((part, index) => {
    const { area, price, floor, category } = part;

    return (
      <div className={styles['row']} key={index}>
        {shouldRenderFloorColumn && (
          <div className={styles['floor']} data-testid="area-parts-floor-column">
            <UIText2>{floor}</UIText2>
          </div>
        )}
        <div className={styles['type']}>
          <UIText2>{category}</UIText2>
        </div>
        <div className={styles['area']}>
          <UIText2>
            <AreaLink href={`${fullUrl}#/area-parts`}>{area}</AreaLink>
          </UIText2>
        </div>
        <div className={styles['price']}>
          <UIText2>{price}</UIText2>
        </div>
      </div>
    );
  });

  return (
    <div className={styles['container']}>
      {rows}
      <MoreAreasPartsLink areaParts={areaParts} numberOfPartsToShow={maxSlotsToShow} href={`${fullUrl}#/area-parts`} />
    </div>
  );
}
